import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBlog, IBlogInitialState } from "./blogModel";
import {
  ActiveInactiveBlog,
  BlogImageUpload,
  createBlog,
  deleteBlog,
  getAllActiveBlog,
  getAllBlog,
  getBlogByID,
  updateBlog,
} from "./services/blog.services";

const initialState: IBlogInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  BlogID: null,
  BlogList: [],
  BlogDetail: {
    ID: null,
    Title: "",
    ShortDescription: "",
    Keyword: "",
    Description: "",
    MetaTitle: "",
    BlogURL: "",
    MetaDescription: "",
    BlogBannerImage: "",
    Image: "",
    BlogDate: "",
    IsActive: 1,
  },
};

const blogSlice = createSlice({
  name: "blog",
  initialState,
  reducers: {
    clearBlogDetails: (state) => {
      state.BlogDetail = initialState.BlogDetail;
    },
    setBlogID: (state, action) => {
      state.BlogID = action.payload;
    },
    clearBlogID: (state) => {
      state.BlogID = initialState.BlogID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllBlog.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllBlog.fulfilled,
      (state, action: PayloadAction<IBlog[]>) => {
        state.loading = false;
        state.BlogList = action.payload || [];
      }
    );
    builder.addCase(getAllBlog.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BlogList = [];
    });
    builder.addCase(createBlog.pending, (state) => {
      state.loading = false;
      state.error = "";
    });
    builder.addCase(createBlog.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createBlog.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateBlog.pending, (state) => {
      state.loading = false;
      state.error = "";
    });
    builder.addCase(updateBlog.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateBlog.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteBlog.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteBlog.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteBlog.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getBlogByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getBlogByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.BlogDetail = action.payload;
    });
    builder.addCase(getBlogByID.rejected, (state, action) => {
      state.loading = false;
      state.BlogDetail = initialState.BlogDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveBlog.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveBlog.fulfilled,
      (state, action: PayloadAction<IBlog[]>) => {
        state.loading = false;
        state.BlogList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveBlog.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BlogList = [];
    });
    builder.addCase(ActiveInactiveBlog.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveBlog.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveBlog.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(BlogImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(BlogImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(BlogImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearBlogDetails, clearBlogID, setBlogID } = blogSlice.actions;
export default blogSlice.reducer;
